/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import clsx from "clsx";
import { Dropdown } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../_helpers";
import { useLang, setLanguage } from "../../../../i18n";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

const languages = [
  {
    lang: "en",
    name: <FormattedMessage id="COMMON.GENERAL.LANGUAGE.EN" />,
    flag: toAbsoluteUrl("/media/svg/flags/226-united-states.svg"),
  },
  {
    lang: "es",
    name: <FormattedMessage id="COMMON.GENERAL.LANGUAGE.ES" />,
    flag: toAbsoluteUrl("/media/svg/flags/252-mexico.svg"),
  }
];

export function LanguageSelectorDropdown() {
  const { lang:userLang } = useSelector((state) => state.auth.user);
  const navLang = useLang();
  const lang = userLang !== null ? userLang : navLang ;
  const currentLanguage =languages.find((x) => x.lang === lang);
  useEffect(() => {
    if (userLang !== navLang) {
      setLanguage(lang);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <Dropdown drop="down" alignRight>
      <Dropdown.Toggle
        as={DropdownTopbarItemToggler}
        id="dropdown-toggle-my-cart"
      >
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip id="language-panel-tooltip"><FormattedMessage id="COMMON.GENERAL.SELECT.LANGUAGE" /></Tooltip>
          }
        >
          <div className="btn btn-icon btn-clean btn-dropdown btn-lg mr-1">
            <img
              className="h-25px w-25px rounded"
              src={currentLanguage.flag}
              alt={currentLanguage.name}
            />
          </div>
        </OverlayTrigger>
      </Dropdown.Toggle>
      <Dropdown.Menu className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround">
        <ul className="navi navi-hover py-4">
          {languages.map((language) => (
            <li
              key={language.lang}
              className={clsx("navi-item", {
                active: language.lang === currentLanguage.lang,
              })}
            >
              <a
                href="#"
                onClick={() => setLanguage(language.lang)}
                className="navi-link"
              >
                <span className="symbol symbol-20 mr-3">
                  <img src={language.flag} alt={language.name} />
                </span>
                <span className="navi-text">{language.name}</span>
              </a>
            </li>
          ))}
        </ul>
      </Dropdown.Menu>
    </Dropdown>
  );
}
